import React from "react";
import { string } from "prop-types";
import "./highlight-text.m.css";

export const HighlightText = ({ children }) => {
  return (
    <div styleName="highlight-text">{children}</div>
  );
};

HighlightText.propTypes = {
  children: string.isRequired,
};